import React from 'react';
import { Modal, ModalFooter, ModalBody, Row } from 'reactstrap';
import FooterButtonsRow from '../shared/FooterButtonsRow/FooterButtonsRow';
import styles from './WhatsCoveredModal.module.css';

const WhatsCoveredModal = ({ isOpen, onCloseModal }) => {
    return (
        <Modal
            isOpen={isOpen}
            aria-modal='true'
            className='md'
            aria-labelledBy='whatsCovered'
            role='dialog'
            centered
        >
            <ModalBody>
                <div className={styles.modalBodyContainer}>
                    <h4>Standalone Theft and Loss Protection Coverage Details</h4>
                    <p>
                        Please visit{' '}
                        <a
                            href=''
                            target='_blank'
                        >
                            %site%
                        </a>{' '}
                        to view full coverage details applicable to your state.
                    </p>
                    <p>
                        Standalone Theft and Loss Protection covers eligible devices including iPhones, Apple Watches
                        and iPads. Plans cover a maximum of two (2) replacements for single device plan and three (3)
                        replacements for multi-device plan within a 12-month period for the following causes of loss:
                        theft or loss of equipment. Coverage begins on your Theft and Loss insurance policy purchase
                        date.
                    </p>
                    <p>
                        A non-refundable deductible, as set forth in the coverage details, is payable at the time a
                        replacement is approved for each replacement.
                    </p>
                    <p>
                        Theft and Loss coverage requires you to have Find My enabled on your device at the time it is
                        lost or stolen. Find My must be enabled and your device should remain associated with your Apple
                        ID throughout the theft or loss claim process. During the claims process, you will be asked to
                        erase your missing device, disable it, and transfer ownership before you can be issued a new
                        device. To ensure that you can sign in and access Find My, it’s important to remember your Apple
                        ID and password and keep your account information up to date. If you use two-factor
                        authentication for Apple ID, it’s recommended that you add an additional trusted phone number to
                        your account so that you can receive the six-digit verification code required to sign in even if
                        your device is missing.
                    </p>
                    <p>
                        Please be advised, the replacement device may not include identical features and functions; may
                        be remanufactured, refurbished and may contain non-original manufacturer parts; and may be a
                        different model, brand and color.
                    </p>
                </div>
            </ModalBody>
            <ModalFooter>
                <FooterButtonsRow
                    isModal
                    buttons={{
                        link: {
                            text: 'Close',
                            onClick: onCloseModal,
                            ariaLabel: 'Click to close modal'
                        }
                    }}
                />
            </ModalFooter>
        </Modal>
    );
};

export default WhatsCoveredModal;
